import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilityServiceService } from '../../../../services/utility-service.service';


@Injectable({
  providedIn: 'root'
})
export class PermitStepperService {

  constructor(private router: Router,public utility: UtilityServiceService) { }
  
  jumpToPermit(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
        if(this.utility.timetableActive){
          document.getElementById('con1-stepper-prev')?.click();
        }
        if(!this.utility.timetableActive){
          document.getElementById('con-stepper-prev')?.click();
        }
        
       }, 100);
       setTimeout(() => {
        if(this.utility.timetableActive){
          document.getElementById('uploads1-stepper-prev')?.click();
        }
        if(!this.utility.timetableActive){
          document.getElementById('uploads-stepper-prev')?.click();
        }
       }, 100);
       setTimeout(() => {
        if(this.utility.timetableActive){
          document.getElementById('timetable-stepper-prev')?.click();
        }
       }, 100);
       setTimeout(() => {
          document.getElementById('motivation-stepper-prev')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('route-stepper-prev')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('vehicle-stepper-prev')?.click();
   }, 100);
    }
  }
  jumpToVehicle(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
          document.getElementById('permit-stepper')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('vehicle-stepper-next')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('route-stepper-next')?.click();
   }, 100);
   setTimeout(() => {
    document.getElementById('motivation-stepper-next')?.click();
 }, 100);
 setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('con-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('con1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  document.getElementById('motivation-stepper-prev')?.click();
}, 100);
setTimeout(() => {
  document.getElementById('route-stepper-prev')?.click();
}, 100);      
     
    }
  }
  jumpToRoutes(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
          document.getElementById('permit-stepper')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('vehicle-stepper-next')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('route-stepper-next')?.click();
   }, 100);
   setTimeout(() => {
    document.getElementById('motivation-stepper-next')?.click();
 }, 100);
 setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('con-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('con1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  document.getElementById('motivation-stepper-prev')?.click();
}, 100);
     
     
    }
  }
  jumpToMotivation(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
          document.getElementById('permit-stepper')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('vehicle-stepper-next')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('route-stepper-next')?.click();
   }, 100);
   setTimeout(() => {
    document.getElementById('motivation-stepper-next')?.click();
 }, 100);
 setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('con-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('con1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-prev')?.click();
  }
}, 100);

     
     
    }
  }
  jumpToTimetables(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
          document.getElementById('permit-stepper')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('vehicle-stepper-next')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('route-stepper-next')?.click();
   }, 100);
   setTimeout(() => {
    document.getElementById('motivation-stepper-next')?.click();
 }, 100);
 setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('con-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('con1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-prev')?.click();
  }
}, 100);


     
     
    }
  }
  jumpToUploads(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
          document.getElementById('permit-stepper')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('vehicle-stepper-next')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('route-stepper-next')?.click();
   }, 100);
   setTimeout(() => {
    document.getElementById('motivation-stepper-next')?.click();
 }, 100);
 setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('con-stepper-prev')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('con1-stepper-prev')?.click();
  }
}, 100);



     
     
    }
  }
  jumpToReview(){
    if (this.router.url.indexOf('edit') != -1 || this.router.url.indexOf('view') != -1) {
      setTimeout(() => {
          document.getElementById('permit-stepper')?.click();
       }, 100);
       setTimeout(() => {
        document.getElementById('vehicle-stepper-next')?.click();
     }, 100);
     setTimeout(() => {
      document.getElementById('route-stepper-next')?.click();
   }, 100);
   setTimeout(() => {
    document.getElementById('motivation-stepper-next')?.click();
 }, 100);
 setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('timetable-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(!this.utility.timetableActive){
    document.getElementById('uploads-stepper-next')?.click();
  }
}, 100);
setTimeout(() => {
  if(this.utility.timetableActive){
    document.getElementById('uploads1-stepper-next')?.click();
  }
}, 100);
     
     
    }
  }
}
